/**
 * Domain enums shared by the API and the web app.
 *
 * Declared as const objects rather than TypeScript `enum` so the values survive
 * `isolatedModules` and match the strings Prisma and GraphQL exchange.
 */
export const QuestionType = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    TRUE_FALSE: 'TRUE_FALSE',
    SHORT_ANSWER: 'SHORT_ANSWER',
    /** Put the options in the authored order. Exact match, no partial credit. */
    ASSOCIATION: 'ASSOCIATION',
    /**
     * Match each item on the left with the one it belongs to on the right.
     *
     * A different question from ASSOCIATION, not a variation of it: that one
     * asks for one sequence over one list of options and is right or wrong as a
     * whole, this one asks for a relation between two lists and every pair is
     * marked on its own.
     */
    MATCHING: 'MATCHING',
};
/**
 * The question set a tutor asks the automatic generator to use.
 *
 * This is a generation preference, not a persisted Practice field: once the
 * Markdown is created, its questions are the source of truth.
 */
export const PracticeGenerationType = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    VARIOUS: 'VARIOUS',
};
/** A provider choice available only through the development override capability. */
export const PracticeGenerationProvider = {
    GEMINI: 'GEMINI',
    OPENAI: 'OPENAI',
};
/** Capabilities an administrator may grant to one user without a deployment. */
export const FeatureFlag = {
    PRACTICE_GENERATION_PROVIDER_OVERRIDE: 'PRACTICE_GENERATION_PROVIDER_OVERRIDE',
    LOCAL_DEVELOPMENT: 'LOCAL_DEVELOPMENT',
};
export const VersionStatus = { DRAFT: 'DRAFT', PUBLISHED: 'PUBLISHED' };
export const AttemptStatus = { IN_PROGRESS: 'IN_PROGRESS', SUBMITTED: 'SUBMITTED' };
export const InvitationKind = {
    STUDENT_JOIN: 'STUDENT_JOIN',
    CO_TUTOR_ACCESS: 'CO_TUTOR_ACCESS',
};
export const QUESTION_TYPES = Object.values(QuestionType);
export function isQuestionType(value) {
    return QUESTION_TYPES.includes(value);
}
//# sourceMappingURL=enums.js.map